// jQuery import - typeahead/Bloodhound is loaded via script tag before this runs
// (typeahead.js UMD requires jQuery as global at evaluation time, can't be bundled with ESM)
import $ from 'jquery';
// Bloodhound is exposed as window.Bloodhound by the script-tag-loaded typeahead.bundle.min.js
const Bloodhound = window.Bloodhound;

// Track one-time global bindings; the main input itself can be re-initialized safely.
var autocompleteInitialized = false;

function getBloodhoundGlobal() {
  if (typeof Bloodhound !== 'undefined' && Bloodhound) {
    return Bloodhound;
  }
  if (typeof window !== 'undefined' && window.Bloodhound) {
    return window.Bloodhound;
  }
  return null;
}

function isHomepageAutocompleteDisabled() {
  return Boolean(
    window.helixDisableHomepageAutocomplete ||
      (document.body && document.body.classList && document.body.classList.contains('helix-route-home'))
  );
}

function destroyTypeaheadInstance($input) {
  if (!$input || $input.length === 0 || !$input.hasClass('tt-input')) {
    return;
  }

  $input.typeahead('destroy');

  var $parent = $input.parent();
  if ($parent.hasClass('twitter-typeahead')) {
    $input.unwrap();
    $parent.find('.tt-menu').remove();
  }
}

function createMainBloodhound(user, BloodhoundGlobal) {
  return new BloodhoundGlobal({
    datumTokenizer: BloodhoundGlobal.tokenizers.obj.whitespace('value'),
    queryTokenizer: BloodhoundGlobal.tokenizers.whitespace,
    remote: {
      url:
        fixtures.inf_server_url +
        '/autocomplete/dataset/%QUERY?' +
        new URLSearchParams({
          secret: (user && user.secret) || '',
          dataset: window.autocompleteDataset || ''
        }),
      wildcard: '%QUERY',
      transform: function (response) {
        return $.map(response['results'] || [], function (dataset) {
          return {
            value: dataset['suggestion'],
            type: dataset['type'],
            typed: response['typed']
          };
        });
      }
    },
    local: ['Show me', 'Show me all', 'Show me the top', 'Show me the smallest'],
    sufficient: 5,
    identify: function (obj) {
      return obj;
    }
  });
}

var EXAMPLE_PROMPTS = [
  { value: 'Show me the top 10 rows', type: 'example' },
  { value: 'Plot a histogram of the data', type: 'example' },
  { value: 'Build a map from the coordinates', type: 'example' },
  { value: 'Compare averages by category', type: 'example' },
  { value: 'Show trends over time', type: 'example' }
];

function initializeMainQueryAutocomplete(user) {
  if (isHomepageAutocompleteDisabled()) {
    return false;
  }

  var textarea = document.getElementById('query');
  if (!textarea || textarea.tagName !== 'TEXTAREA') {
    return false;
  }
  if (textarea.dataset.helixAcBound === '1') {
    return true;
  }
  textarea.dataset.helixAcBound = '1';

  function autogrow() {
    textarea.style.height = 'auto';
    var maxH = 240;
    var h = Math.min(textarea.scrollHeight, maxH);
    textarea.style.height = h + 'px';
    textarea.style.overflowY = textarea.scrollHeight > maxH ? 'auto' : 'hidden';
  }

  var menu = document.getElementById('helix-ac-menu');
  if (!menu) {
    menu = document.createElement('div');
    menu.id = 'helix-ac-menu';
    menu.className = 'helix-ac-menu';
    document.body.appendChild(menu);
  }

  var suggestions = [];
  var activeIdx = -1;
  var fetchController = null;
  var debounceTimer = null;
  var lastFetchedQuery = '';

  function shouldFetchAutocomplete(q) {
    var trimmed = (q || '').trim();
    if (!trimmed) {
      return true;
    }
    if (trimmed.length < 3) {
      return false;
    }
    if (trimmed === lastFetchedQuery) {
      return false;
    }
    return true;
  }

  function positionMenu() {
    var rect = textarea.getBoundingClientRect();
    menu.style.left = (rect.left + window.scrollX) + 'px';
    // Width sizes to content up to a sensible cap
    menu.style.maxWidth = Math.max(320, rect.width) + 'px';
    // offsetHeight is 0 while the menu is still display:none, so estimate
    // from the item count (matches CSS: ~30px/item, 280px max-height cap).
    var menuH = menu.offsetHeight || Math.min(suggestions.length * 30 + 10, 280);
    var below = window.innerHeight - rect.bottom;
    var above = rect.top;
    if (below < menuH + 12 && above > below) {
      menu.style.top = (rect.top + window.scrollY - menuH - 4) + 'px';
    } else {
      menu.style.top = (rect.bottom + window.scrollY + 4) + 'px';
    }
  }

  function renderMenu() {
    if (!suggestions.length) {
      hideMenu();
      return;
    }
    menu.innerHTML = '';
    suggestions.forEach(function (s, i) {
      var item = document.createElement('div');
      item.className = 'helix-ac-item' + (i === activeIdx ? ' is-active' : '');
      if (s.typed) {
        var t = document.createElement('span');
        t.className = 'helix-ac-typed';
        t.textContent = s.typed;
        item.appendChild(t);
      }
      var v = document.createElement('span');
      v.textContent = s.value;
      item.appendChild(v);
      if (s.type && s.type !== 'data') {
        var k = document.createElement('span');
        k.className = 'helix-ac-kind';
        k.textContent = s.type;
        item.appendChild(k);
      }
      item.addEventListener('mousedown', function (e) {
        e.preventDefault();
        applySuggestion(i);
      });
      menu.appendChild(item);
    });
    // Open first so offsetHeight is measurable, then position (twice is
    // cheap; the second pass uses the real height after layout).
    menu.classList.add('is-open');
    positionMenu();
    positionMenu();
  }

  function hideMenu() {
    menu.classList.remove('is-open');
    activeIdx = -1;
  }

  function applySuggestion(i) {
    var s = suggestions[i];
    if (!s) return;
    var val = s.typed && s.typed.length > 0 ? s.typed + ' ' + s.value : s.value;
    textarea.value = val;
    autogrow();
    hideMenu();
    textarea.focus();
    textarea.setSelectionRange(val.length, val.length);
    textarea.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function fetchSuggestions(q) {
    if (!shouldFetchAutocomplete(q)) {
      return;
    }
    if (fetchController) {
      try { fetchController.abort(); } catch (_) {}
    }
    if (!q || !q.trim()) {
      lastFetchedQuery = '';
      hideMenu();
      return;
    }
    lastFetchedQuery = q.trim();
    fetchController = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var baseUrl = (window.fixtures && window.fixtures.inf_server_url) || '';
    var url = baseUrl + '/autocomplete/dataset/' + encodeURIComponent(q) +
      '?secret=' + encodeURIComponent((user && user.secret) || '') +
      '&dataset=' + encodeURIComponent(window.autocompleteDataset || '');
    var opts = fetchController ? { signal: fetchController.signal } : {};
    fetch(url, opts)
      .then(function (r) { return r.ok ? r.json() : { results: [] }; })
      .then(function (data) {
        var results = (data && data.results) || [];
        var typed = (data && data.typed) || '';
        suggestions = results.map(function (r) {
          return { value: r.suggestion, type: r.type, typed: typed };
        });
        if (suggestions.length < 3) {
          var extras = EXAMPLE_PROMPTS.slice(0, 3 - suggestions.length);
          suggestions = suggestions.concat(extras);
        }
        activeIdx = -1;
        renderMenu();
      })
      .catch(function (err) {
        if (err && err.name !== 'AbortError') {
          console.warn('autocomplete fetch failed', err);
          suggestions = EXAMPLE_PROMPTS.slice();
          activeIdx = -1;
          renderMenu();
        }
      });
  }

  textarea.addEventListener('input', function () {
    autogrow();
    clearTimeout(debounceTimer);
    var val = textarea.value;
    debounceTimer = setTimeout(function () { fetchSuggestions(val); }, 450);
  });

  textarea.addEventListener('pointerdown', function () {
    if (!textarea.value.trim()) {
      suggestions = EXAMPLE_PROMPTS.slice();
      activeIdx = -1;
      renderMenu();
    }
  });

  textarea.addEventListener('blur', function () {
    setTimeout(function () {
      if (document.activeElement !== textarea && !menu.matches(':hover')) hideMenu();
    }, 150);
  });

  textarea.addEventListener('keydown', function (e) {
    var open = menu.classList.contains('is-open');
    if (!open) return;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      e.stopPropagation();
      activeIdx = Math.min(activeIdx + 1, suggestions.length - 1);
      renderMenu();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      e.stopPropagation();
      activeIdx = Math.max(activeIdx - 1, -1);
      renderMenu();
    } else if (e.key === 'Enter' && !e.shiftKey && activeIdx >= 0) {
      e.preventDefault();
      e.stopPropagation();
      applySuggestion(activeIdx);
    } else if (e.key === 'Enter' && !e.shiftKey) {
      hideMenu();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      hideMenu();
    } else if (e.key === 'Tab' && activeIdx >= 0) {
      e.preventDefault();
      applySuggestion(activeIdx);
    }
  });

  document.addEventListener('click', function (e) {
    if (!menu.contains(e.target) && e.target !== textarea) {
      hideMenu();
    }
  });

  window.addEventListener('resize', positionMenu);
  window.addEventListener('scroll', positionMenu, true);

  autogrow();
  return true;
}

function initializeMainTypeahead(user, BloodhoundGlobal) {
  if (isHomepageAutocompleteDisabled()) {
    return;
  }

  if (initializeMainQueryAutocomplete(user)) {
    // expose something compatible for legacy callers
    window.typeaheadBox = $('#query');
    return;
  }

  var $typeaheadElement = $('#remote .typeahead');
  if ($typeaheadElement.length === 0) {
    return;
  }

  // Bloodhound is an optional dependency used only by legacy text inputs.
  // Keep the page functional when its asset is blocked or unavailable.
  if (!BloodhoundGlobal) {
    console.warn('Legacy Typeahead autocomplete unavailable: Bloodhound did not load.');
    return;
  }

  if (typeof $.fn.typeahead !== 'function') {
    console.error('typeahead jQuery plugin not registered on $.fn');
    return;
  }

  destroyTypeaheadInstance($typeaheadElement);

  var bloodhoundInstance = createMainBloodhound(user, BloodhoundGlobal);
  window.typeaheadBox = $typeaheadElement
    .typeahead(null, {
      name: 'query-autocomplete',
      display: function (data) {
        if (data.typed && data.typed.length > 0) {
          return data.typed + ' ' + data.value;
        }
        return data.value;
      },
      source: bloodhoundInstance,
      minLength: 0,
      limit: 10,
      templates: {
        suggestion: function (data) {
          var displayType = data.type || '';
          if (data.type == 'data') {
            displayType = '';
          }
          return `<div><span class="typed-already">${data.typed}</span> <span class="typing-suggestion">${data.value}</span> <span class="typing-type">${displayType}</span></div>`;
        }
      }
    })
    .on('typeahead:render', function () {
      var $input = $(this);
      var $menu = $input.parent().find('.tt-menu');
      var inputOffset = $input.offset();
      var inputHeight = $input.outerHeight();
      var menuHeight = $menu.outerHeight();

      if (inputOffset.top + inputHeight + menuHeight > $(window).height()) {
        $menu.css({
          top: 'auto',
          bottom: '100%'
        });
      } else {
        $menu.css({
          top: '100%',
          bottom: 'auto'
        });
      }
    });

}

// Core setup logic extracted for reuse
function setupAutocomplete(user) {
  if (isHomepageAutocompleteDisabled()) {
    return;
  }

  window.autocompleteDataset = '';

  const BloodhoundGlobal = getBloodhoundGlobal();
  $(document).ready(function () {
    // Resolve again at DOM-ready so a late same-origin script load can recover.
    initializeMainTypeahead(user, BloodhoundGlobal || getBloodhoundGlobal());
  });

  // Legacy edit-field autocomplete also requires Bloodhound. The main textarea
  // was scheduled above and remains fully functional without this optional path.
  if (!BloodhoundGlobal) {
    return;
  }

  window.addNewAutocompleterEditElement = function (element, dataset, query, edits, chartType) {
        // delete old instances + add a new bloodhound and typeahead instance for an element/dataset
        var $toTypeahead = $(element);

        destroyTypeaheadInstance($toTypeahead);

        query = query || '';
        if (edits && edits.length > 0) {
          query = query + edits.join(', ');
        }
        var editModebloodhoundInstance = new BloodhoundGlobal({
          datumTokenizer: BloodhoundGlobal.tokenizers.obj.whitespace('value'),
          queryTokenizer: BloodhoundGlobal.tokenizers.whitespace,
          // prefetch: '../data/films/post_1960.json',
          remote: {
            url:
              fixtures.inf_server_url +
              '/autocomplete_editmode?edit=%QUERY&' +
              new URLSearchParams({
                secret: (user && user.secret) || '',
                dataset: dataset,
                query: query,
                chart_type: chartType
              }),
            wildcard: '%QUERY',
            transform: function (response) {
              // Map the remote source JSON array to a JavaScript object array
              return $.map(response['results'], function (dataset) {
                return {
                  value: dataset['suggestion'],
                  type: dataset['type'],
                  typed: response['typed']
                };
              });
            }
          },
          local: ['Show me', 'Show me all', 'Show me the top', 'Show me the smallest'],
          // start at 0 characters typed
          // limit: 10,
          // cache: false,
          sufficient: 5,
          identify: function (obj) {
            return obj;
          }
        });
        $toTypeahead.typeahead(null, {
          name: 'best-pictures',
          display: function (data) {
            if (data.typed && data.typed.length > 0) {
              return data.typed + ' ' + data.value;
            }
            return data.value;
          },
          source: editModebloodhoundInstance,
          minLength: 0,
          limit: 10,
          templates: {
            suggestion: function (data) {
              var displayType = data.type;
              if (data.type == 'data') {
                displayType = '';
              }
              return `<div><span class="typed-already">${data.typed}</span> <span class="typing-suggestion">${data.value}</span> <span class="typing-type">${displayType}</span></div>`;
            }
          }
        });
      };
  if (autocompleteInitialized) {
    return;
  }

  autocompleteInitialized = true;

  $(document).ready(function () {
      //fix to re show results on click
      $(document).on('click', '.tt-current-query', function () {
        var input = $(this).closest('.twitter-typeahead').find('input.tt-input');
        input.trigger('keypress');
      });
  });

  /*  microphone
   */
  function resolveSpeechTarget($trigger) {
    var $scope = $trigger.closest('form');
    if ($scope.length === 0) {
      $scope = $trigger.closest('#remote, .chat-header, .draggable-header');
    }
    if ($scope.length === 0) {
      $scope = $(document.body);
    }

    var selectors = [
      'input.tt-input:visible',
      '#query:visible',
      '#editquery:visible',
      '#editchatquery:visible',
      '.typeahead:visible',
      'textarea:visible',
      'input[type="text"]:visible',
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var $candidate = $scope.find(selectors[i]).not('[type="hidden"]').first();
      if ($candidate.length > 0) {
        return $candidate.get(0);
      }
    }

    return null;
  }

  function setMicActiveState($mic, active) {
    var icon = $mic.find('span')[0];
    if (active) {
      $mic.addClass('pulse');
      $mic.addClass('redish-icon');
      if (icon) {
        icon.innerHTML = 'mic_off';
      }
      return;
    }

    $mic.removeClass('pulse');
    $mic.removeClass('redish-icon');
    if (icon) {
      icon.innerHTML = 'mic';
    }
  }

  function insertTranscriptIntoTarget(target, text) {
    if (!target || !text) {
      return;
    }

    if (window.DictatorFlowSTT && typeof window.DictatorFlowSTT.insertText === 'function') {
      window.DictatorFlowSTT.insertText(target, text);
      return;
    }

    if (typeof target.value === 'string') {
      target.value = target.value ? target.value + ' ' + text : text;
      target.dispatchEvent(new Event('input', { bubbles: true }));
      target.dispatchEvent(new Event('change', { bubbles: true }));
      target.focus();
    }
  }

  $(document).on('click', '.mic-talk', function (event) {
    event.preventDefault();

    if (!window.DictatorFlowSTT || typeof window.DictatorFlowSTT.open !== 'function') {
      console.error('DictatorFlow STT widget not available');
      return;
    }

    var $trigger = $(this);
    if ($trigger.data('dictatorflowBusy')) {
      return;
    }

    var target = resolveSpeechTarget($trigger);
    var title = target && target.id && target.id.indexOf('edit') === 0
      ? 'Edit this graph by voice'
      : 'Speak your Helix query';

    $trigger.data('dictatorflowBusy', true);
    setMicActiveState($trigger, true);

    window.DictatorFlowSTT.open({
      endpoint: '/api/speech-to-text',
      title: title,
      subtitle: 'Press Enter to transcribe. Press Esc to cancel.',
      target: target,
      onResult: function (text) {
        insertTranscriptIntoTarget(target, text);
      },
      onError: function (error) {
        console.error('DictatorFlow STT failed', error);
      },
    })
      .catch(function (error) {
        console.error('DictatorFlow STT failed', error);
      })
      .finally(function () {
        setMicActiveState($trigger, false);
        $trigger.removeData('dictatorflowBusy');
      });
  });
} // End of setupAutocomplete function

// Initialize autocomplete - listen for both native and jQuery user-ready events
function initializeAutocomplete() {
  // Native CustomEvent listener (dispatched by simpleauth)
  document.addEventListener('user-ready', function(evt) {
    var user = evt.detail || {};
    setupAutocomplete(user);
  });

  // jQuery trigger fallback
  $(document).on('user-ready', function(evt, user) {
    // Prefer CustomEvent detail if present
    var eventDetailUser = evt && evt.originalEvent && evt.originalEvent.detail ? evt.originalEvent.detail : null;
    if (!user && eventDetailUser) {
      user = eventDetailUser;
    }
    setupAutocomplete(user || {});
  });
}

// Start initialization
initializeAutocomplete();
